<pl-bar-chart
  *ngIf="block && block.data"
  [title]="block.data.title"
  [barsDef]="block.data.bars"
  [barWidth]="block.data.barWidth"
/>
